import {BulkActionTypes} from "./types";

import {ActionCreator, Action, Dispatch} from "redux";
import {ThunkAction} from "redux-thunk";

import {ApplicationState} from "../index";
import config from "../../config";
import { responseHandler } from "utils";

const { api } = config;

const DTS_API_STUDENT = api.DTS_API_STUDENT

export type AppThunk = ActionCreator<ThunkAction<void, ApplicationState, null, Action<string>>>;

export const bulkUpdateRequest: AppThunk = (model, data, handleSuccess, handleError, successPopup) => {
    let method:any = successPopup ==="hidepopup" ?'GET':null
    return async (dispatch: Dispatch, getState): Promise<void> => {
        const { auth: { token } } = getState();
        dispatch({
            type: BulkActionTypes.PUT_BULK_REQUEST
        });
        const headers = new Headers();
        headers.append('Content-Type', 'application/json');
        if (token) {
            headers.append('token', token);
        }   
        const response = await fetch(
            `${DTS_API_STUDENT}/models/${model}/bulk`,
            {
                method: "PUT",
                headers: headers,
                body: JSON.stringify(data)
            }
        );
                      
        // const error = {
        //     204: {
        //         "message": "Records updated Successfully",
        //         "success": true
        //     },
        //     200: {
        //         "message": "Records updated Successfully",
        //         "success": true
        //     }
        // }  
        await responseHandler(response, dispatch, BulkActionTypes.PUT_BULK_SUCCESS, BulkActionTypes.PUT_BULK_ERROR, "", "", "", "GET");
    };
};

export const bulkDelete: AppThunk = (model, ids, handleSuccess, handleError) => {
    return async (dispatch: Dispatch, getState): Promise<void> => {
        const { auth: { token } } = getState();
        dispatch({
            type: BulkActionTypes.DELETE_BULK_REQUEST
        });
        const headers = new Headers();
        headers.append('Content-Type', 'application/json');
        if (token) {
            headers.append('token', token);
        } 
        const response = await fetch(`${DTS_API_STUDENT}/models/${model}/bulk`, {
            method: "DELETE",
            headers: headers,
            body: JSON.stringify(ids)
        });
        try {
            const error = {
                204: {
                    "message": "Records deleted Successfully",
                    "success": true
                },
                200: {
                    "message": "Records deleted Successfully",
                    "success": true
                }
            }  
            await responseHandler(response, dispatch, BulkActionTypes.DELETE_BULK_SUCCESS, BulkActionTypes.DELETE_BULK_ERROR, error, handleSuccess, handleError);
       
        } catch (error) {
            console.error("Error parsing response body:", error);
            dispatch({
                type: BulkActionTypes.DELETE_BULK_ERROR
            });
            handleSuccess();
        }
    };
};
